import { NgModule } from '@angular/core';
import { NotificationsComponent } from './notifications.component';
import { ToastrModule } from 'ngx-toastr';
import { NgClass } from '@angular/common';


@NgModule({
  declarations: [
    NotificationsComponent
  ],
  imports: [
    NgClass,
    ToastrModule.forRoot({
      toastComponent: NotificationsComponent,
      newestOnTop: false,
      preventDuplicates: true,
      autoDismiss: true,
      maxOpened: 5,
      tapToDismiss: false,
      positionClass: 'toast-bottom-center'
    })
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }
